import { BranchInitEvent } from "capacitor-branch-deep-links";
import { analytics } from "lib/analytics";
import { IS_IN_APP_BROWSER_SEARCH_PARAM } from "lib/app";
import { getPathFromReferringParams } from "lib/app/branch";
import { PushNotificationData } from "lib/app/types";
import { Sentry } from "lib/sentry";
import Router from "next/router";
import { AppOpenEventData, schema } from "shared/analytics";
import { extractBranchPreviewHost, extractSchemePath } from "../parsers";

export type RuntimeHandler = (url: string) => boolean | Promise<boolean>;

export const handleSchemePath: RuntimeHandler = (url) => {
  const path = extractSchemePath(url);

  analytics.trackEvent<AppOpenEventData>(schema.APP_OPENED_BY_URL, {
    path,
    appColdStart: false,
  });

  if (path) {
    Router.push(path).catch((err) => {
      console.error(err);
      Sentry.captureException(err);
    });
    return true;
  }

  return false;
};

export const handleBranchPreviewUrl: RuntimeHandler = (url = "") => {
  const host = extractBranchPreviewHost(url);

  if (host) {
    window.location.href = `https://${host}/app/launch`;
    return true;
  }

  return false;
};

export const handleOpenInAppBrowser = async (
  notificationData: PushNotificationData
) => {
  if (notificationData?.open_in_browser) {
    const url = new URL(notificationData.click_action);
    url.searchParams.set(IS_IN_APP_BROWSER_SEARCH_PARAM, "1");
    await window.Capacitor.Plugins.Browser.open({
      url: url.toString(),
    });
  }
};

export const handleBranchDeepLink = async (event: BranchInitEvent) => {
  const path = getPathFromReferringParams(event.referringParams);

  if (path) {
    analytics.trackEvent<AppOpenEventData>(schema.APP_OPENED_BY_URL, {
      path,
      appColdStart: false,
    });

    await Router.push(path);
  }
};
